import { render, staticRenderFns } from "./ReservierungVorbestellungProdukte.vue?vue&type=template&id=c0f3cea6"
import script from "./ReservierungVorbestellungProdukte.vue?vue&type=script&lang=ts"
export * from "./ReservierungVorbestellungProdukte.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports